import {
    handleDropinError,
    processPaymentResult,
    sendBankCheckDetails,
    sendBankCheckStartForAttempt,
    startGatedPayment,
} from "./paymentPage.flow";

export function createPaymentPageDropinCallbacks(pageContext) {
    function handleBeforeSubmit(paymentData, component, actions) {
        startGatedPayment(pageContext, paymentData, component, actions);
    }

    function handleActionHandled() {
        sendBankCheckStartForAttempt(pageContext);
    }

    function handleAdditionalDetails(detailsState, component, actions) {
        sendBankCheckDetails(pageContext, detailsState, actions);
    }

    function handlePaymentFinished(paymentResult) {
        processPaymentResult(pageContext, paymentResult);
    }

    function handleCheckoutError(error) {
        handleDropinError(pageContext, error);
    }

    return Object.freeze({
        beforeSubmit: handleBeforeSubmit,
        onActionHandled: handleActionHandled,
        onAdditionalDetails: handleAdditionalDetails,
        onPaymentCompleted: handlePaymentFinished,
        onPaymentFailed: handlePaymentFinished,
        onError: handleCheckoutError,
    });
}
